export const url = 'https://theswex.com'
const type = 'website'
const fallbackTitle = 'THE SWEX'
const description = 'Exchange for Scotch single malt whisky'
const mainImage = '/favicon.png'
const siteName = 'THE SWEX'

export const createMetaTags = (meta) => {
  return [
    {
      hid: 'description',
      name: 'description',
      content: (meta.description && meta.description) || description,
    },
    {
      hid: 'og:type',
      property: 'og:type',
      content: (meta.type && meta.type) || type,
    },
    {
      hid: 'og:url',
      property: 'og:url',
      content: (meta.url && meta.url) || url,
    },
    {
      hid: 'og:title',
      property: 'og:title',
      content: (meta.title && meta.title) + ' - THE SWEX' || fallbackTitle,
    },
    {
      hid: 'og:description',
      property: 'og:description',
      content: (meta.description && meta.description) || description,
    },
    {
      hid: 'og:image',
      property: 'og:image',
      content: (meta.mainImage && meta.mainImage) || mainImage,
    },
    {
      hid: 'og:site_name',
      proptery: 'og:site_name',
      content: (meta.siteName && meta.siteName) || siteName,
    },
    {
      hid: 'twitter:url',
      name: 'twitter:url',
      content: (meta.url && meta.url) || url,
    },
    {
      hid: 'twitter:title',
      name: 'twitter:title',
      content: (meta.title && meta.title) + ' - THE SWEX' || fallbackTitle,
    },
    {
      hid: 'twitter:description',
      name: 'twitter:description',
      content: (meta.description && meta.description) || description,
    },
    {
      hid: 'twitter:image',
      name: 'twitter:image',
      content: (meta.mainImage && meta.mainImage) || mainImage,
    },
  ]
}
